import { clsx } from 'clsx';
import { PaletteUtils } from '@shared/utils';
import type { GetAccountUsersResponse } from '@shared/api/rest/users';
import { ColorsEnum, NoData, Text } from '@shared/widgets';

interface IManagersProps {
  data: GetAccountUsersResponse[];
}

export const Managers = (props: IManagersProps) => {
  return (
    <div className='flex gap-6 overflow-auto'>
      {props.data.length > 0 ? (
        <>
          {props.data.map((item, key) => (
            <div key={key} className='items-center rounded-sm flex gap-2 p-3 bg-white dark:bg-soft-black'>
              <div
                className={clsx(
                  'items-center flex flex-none justify-center h-9 w-9 text-ice mr-3 rounded-3xl',
                  PaletteUtils.isInsigniaPalette && 'bg-soft-black dark:bg-primary',
                  PaletteUtils.isVcfcPalette && 'bg-primary',
                )}
              >
                <Text color={ColorsEnum.White}>{item?.displayName[0].toUpperCase()}</Text>
              </div>
              <div className='flex-1 flex-col justify-center gap-0.5'>
                <Text>{item.displayName}</Text>
              </div>
            </div>
          ))}
        </>
      ) : (
        <NoData text='No related records' />
      )}
    </div>
  );
};
